import * as formik from 'formik';
import * as yup from 'yup';

import { Col, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

import AppButton from '../../commons/buttons/AppButton';
import AppContainer from '../../commons/containers/AppContainer';
import AppInput from '../../commons/inputs/AppInput';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import CompanyAPI from '../company/CompanyAPI';
import HallAppToast from '../../commons/HallAppToast';
import MachineAPI from './MachineAPI';

const companyAPI = new CompanyAPI();
const machineAPI = new MachineAPI();
function ModalMachine({ closeShow, show, callMachines, machine }) {

    const [isLoading, setIsLoading] = useState(false)
    const [useCustomFees, setUseCustomFees] = useState(false);
    const [installmentFees, setInstallmentFees] = useState({});

    const [initialValues, setInitialValues] = useState({
        name: '',
        debitFee: '',
        creditFee: '',
        creditInstallmentFee: '',
        pixFee: '',
    });

    useEffect(() => {
        if (machine && Object.keys(machine).length > 0) {
            const feesObject = {};
            if (machine.installmentFees) {
                machine.installmentFees.forEach(fee => {
                    feesObject[fee.installments] = fee.feePercentage;
                });
            }

            setUseCustomFees(machine.installmentFees?.length > 0);
            setInstallmentFees(feesObject);

            setInitialValues({
                name: machine.name || '',
                debitFee: machine.debitFee || '',
                creditFee: machine.creditFee || '',
                pixFee: machine.pixFee || '',
                creditInstallmentFee: machine.creditInstallmentFee || '',
                maxInstallments: machine.maxInstallments || '',
                installmentFee: machine.installmentFee || ''
            });
        }
    }, [machine]);


    const { Formik } = formik;

    const schema = yup.object().shape({
        name: yup.string().required('Informe um nome para maquininha').max(15, 'Nome deve ter no maximo 15 cracteres'),
        debitFee: yup.string(),
        pixFee: yup.string(),
        creditFee: yup.string(),
        creditInstallmentFee: yup.string(),
        installmentFee: yup.string(),
        maxInstallments: yup.string(),
    });

    const handleFeeChange = (installment, value) => {
        setInstallmentFees((prev) => ({
            ...prev,
            [installment]: value
        }));
    };

    const save = async (values) => {
        const max = Number(values.maxInstallments) || 0;

        const filteredFees = Object.entries(installmentFees)
            .filter(([installment]) => Number(installment) >= 1 && Number(installment) <= max)
            .map(([installment, fee]) => ({
                installments: Number(installment),
                feePercentage: Number(fee)
            }));

        const data = {
            companyId: companyAPI.getCompanyManagment().id,
            name: values.name,
            debitFee: values.debitFee,
            creditFee: values.creditFee,
            creditInstallmentFee: useCustomFees ? null : values.creditInstallmentFee,
            maxInstallments: max,
            useCustomFees: useCustomFees,
            installmentFee: useCustomFees ? null : values.installmentFee,
            installmentFees: useCustomFees ? filteredFees : [],
            pixFee: values.pixFee
        };

        setIsLoading(true)
        try {
            if (machine?.id) {
                await machineAPI.updateMachine(machine?.id, data);
            } else {
                await machineAPI.createMachine(data);
            }
            HallAppToast.success();
            if (callMachines) {
                callMachines();
                closeShow()
            }
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    };

    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        ADICIONAR MAQUININHA
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Formik
                        validationSchema={schema}
                        onSubmit={save}
                        initialValues={initialValues}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                            <AppContainer>
                                <Form noValidate onSubmit={handleSubmit}>
                                    <AppInput errors={errors}
                                        isRequired
                                        touched={touched}
                                        name='name'
                                        onChange={handleChange}
                                        value={values.name}
                                        type='text'
                                        label='Nome' />

                                    <AppInput errors={errors}
                                        touched={touched}
                                        name='debitFee'
                                        onChange={handleChange}
                                        value={values.debitFee}
                                        type='number'
                                        label='Taxa no débito (%)' />

                                    <AppInput errors={errors}
                                        touched={touched}
                                        name='pixFee'
                                        onChange={handleChange}
                                        value={values.pixFee}
                                        type='number'
                                        label='Taxa no PIX (%)' />

                                    <AppInput errors={errors}
                                        touched={touched}
                                        name='creditFee'
                                        onChange={handleChange}
                                        value={values.creditFee}
                                        type='number'
                                        label='Taxa no crédito à vista (%)' />

                                    <AppInput errors={errors}
                                        touched={touched}
                                        name='maxInstallments'
                                        onChange={handleChange}
                                        value={values.maxInstallments}
                                        type='number'
                                        label='Número máximo de parcelas' />

                                    <>
                                        <p>Deseja configurar taxas diferentes por número de parcelas?</p>

                                        <Form.Check
                                            type="radio"
                                            id="custom-fees-no"
                                            name="customFees"
                                            label="Não, quero usar uma taxa padrão de parcelamento"
                                            checked={useCustomFees === false}
                                            onChange={() => setUseCustomFees(false)}
                                        />

                                        {!useCustomFees && (
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='installmentFee'
                                                onChange={handleChange}
                                                value={values.installmentFee}
                                                type='number'
                                                label='Taxa padrão de parcelamento (%)'
                                            />
                                        )}

                                        <Form.Check
                                            type="radio"
                                            id="custom-fees-yes"
                                            name="customFees"
                                            label="Sim, quero configurar taxas por parcela"
                                            checked={useCustomFees === true}
                                            onChange={() => setUseCustomFees(true)}
                                        />

                                        {useCustomFees && (
                                            <div className="mt-3">
                                                <h5>Taxas por número de parcelas</h5>
                                                {[...Array(Number(values.maxInstallments) || 0)].map((_, index) => {
                                                    const installment = index + 1;
                                                    return (
                                                        <Row key={installment} className="mb-2">
                                                            <Col xs={4}>
                                                                <Form.Label>{installment}x</Form.Label>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <Form.Control
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    placeholder="Taxa %"
                                                                    value={installmentFees[installment] || ''}
                                                                    onChange={(e) =>
                                                                        handleFeeChange(installment, e.target.value)
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </>
                                    {isLoading ? <div style={{ textAlign: 'center' }}>
                                        <AppLoading />
                                    </div> :
                                        <AppButton type="submit" width='100%' name='salvar' />
                                    }
                                    <div style={{ marginTop: '10px' }}>
                                        <AppLinkButton name="fechar" onClick={closeShow} />
                                    </div>
                                </Form>

                            </AppContainer>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalMachine;